import { Link } from 'react-router-dom';
import { dramaCategories } from '@/mocks/dramas';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-heading font-bold text-accent-500">
                97<span className="text-background-50">影视</span>
              </span>
            </Link>
            <p className="text-sm text-background-50/70 leading-relaxed">
              97影视致力于为用户提供最全最新的电视剧在线观看服务，涵盖国产剧、韩剧、美剧、日剧等多种类型，高清流畅，追剧首选。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/hot" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors whitespace-nowrap">
                  热播推荐
                </Link>
              </li>
              <li>
                <Link to="/category/chinese" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors whitespace-nowrap">
                  国产剧
                </Link>
              </li>
              <li>
                <Link to="/category/korean" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors whitespace-nowrap">
                  韩剧
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">分类浏览</h4>
            <ul className="space-y-2.5">
              {dramaCategories.filter(c => c.slug !== 'all').map(cat => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/70 hover:text-accent-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors whitespace-nowrap">
                  品牌介绍
                </Link>
              </li>
              <li>
                <a href="mailto:contact@97yingshi.com" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors whitespace-nowrap">
                  联系我们
                </a>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-accent-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-accent-500 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-accent-500 transition-colors" aria-label="邮箱">
                <i className="ri-mail-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="py-5 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/50">
            &copy; {new Date().getFullYear()} 97影视 版权所有 | 本站内容仅供学习交流使用
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/50">
            <a href="#" className="hover:text-background-50/80 transition-colors whitespace-nowrap">用户协议</a>
            <a href="#" className="hover:text-background-50/80 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-background-50/80 transition-colors whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}